import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { consultationApi } from '../../api/consultationApi';
import { BookingCard } from './AdvocateConsultationPanel';
import '../../styles/consultation.css';

const UserConsultations = () => {
  const [tab, setTab] = useState('upcoming');
  const [bookings, setBookings] = useState([]);

  const load = async () => {
    try {
      const res = await consultationApi.getMyBookings('video');
      setBookings(res.data.bookings || []);
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Unable to load your video consultations');
    }
  };

  useEffect(() => { load(); }, []);

  const grouped = useMemo(() => {
    const upcoming = bookings.filter((x) =>
      ['upcoming', 'confirmed', 'in_progress', 'paid', 'pending'].includes(x.displayStatus) ||
      ['confirmed', 'in_progress', 'paid', 'pending'].includes(x.status)
    );
    const completed = bookings.filter((x) => x.status === 'completed');
    const history = bookings.filter((x) => ['completed', 'cancelled', 'no_show'].includes(x.status));
    return { upcoming, completed, history };
  }, [bookings]);

  return (
    <div className="consult-panel">
      <h3>My Video Consultations</h3>
      <div className="consult-tabs">
        <button type="button" className={`consult-tab ${tab === 'upcoming' ? 'active' : ''}`} onClick={() => setTab('upcoming')}>Upcoming</button>
        <button type="button" className={`consult-tab ${tab === 'completed' ? 'active' : ''}`} onClick={() => setTab('completed')}>Completed</button>
        <button type="button" className={`consult-tab ${tab === 'history' ? 'active' : ''}`} onClick={() => setTab('history')}>History</button>
      </div>
      <div className="consult-card-list">
        {(grouped[tab] || []).length === 0 ? (
          <div className="empty-consult">No video consultations here yet.</div>
        ) : (
          grouped[tab].map((booking) => (
            <BookingCard
              key={booking._id}
              booking={booking}
              counterpart={booking.advocateId}
              isAdvocate={false}
              onChanged={load}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default UserConsultations;
